import { render, staticRenderFns } from "./ServicePurchase.vue?vue&type=template&id=11cd5c4d"
import script from "./ServicePurchase.vue?vue&type=script&lang=js"
export * from "./ServicePurchase.vue?vue&type=script&lang=js"
import style0 from "./ServicePurchase.vue?vue&type=style&index=0&id=11cd5c4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports